module.exports = __webpack_public_path__ + "img/f_c_sc_4.46556fb7.png";